// Google G1 (saved Google connections) public configuration.
//
// GOOGLE_PICKER_APP_ID must be the Google Cloud PROJECT NUMBER confirmed by
// the project owner in Google Cloud Console. It is never inferred from the
// OAuth client ID prefix. While null, Connect stays disabled ("Setup required").
export const GOOGLE_PICKER_APP_ID: string | null = '246728604742';

/** Single registered OAuth callback. No alternate domains. */
export const GOOGLE_G1_REDIRECT_URI = 'https://theworkitect.com/integrations/google/callback';
export const GOOGLE_G1_CALLBACK_PATH = '/integrations/google/callback';
/** Only this origin can start a connection (the callback must share its session). */
export const GOOGLE_G1_ALLOWED_ORIGINS = ['https://theworkitect.com'];
